
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#C3AFA3","d":"M7.8 0a7.8 7.8 0 107.8 7.8A7.808 7.808 0 007.8 0zm.163 3.25a.975.975 0 110 1.95.975.975 0 010-1.95zm1.462 8.775h-2.6a.65.65 0 110-1.3h.487c.09 0 .163-.073.163-.162V7.636a.163.163 0 00-.162-.162h-.488a.65.65 0 110-1.3h.65a1.3 1.3 0 011.3 1.3v3.088c0 .09.073.162.162.162h.488a.65.65 0 110 1.3z"}})])
          )
        }
      }
    